module.exports = __webpack_public_path__ + "img/ic_recognition.1104fb42.png";